import { render } from "./GameCard.vue?vue&type=template&id=761f2e5a&scoped=true"
import script from "./GameCard.vue?vue&type=script&lang=js"
export * from "./GameCard.vue?vue&type=script&lang=js"

import "./GameCard.vue?vue&type=style&index=0&id=761f2e5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761f2e5a"]])

export default __exports__